<template>
  <ContractsTable />
</template>

<script>
import ContractsTable from './components/ContractsTable.vue'

export default {
  components: {
    ContractsTable,
  },
}
</script>
